import React from 'react';

import { Text } from '@betterment/samba-react';

import type { EmployersResult } from './data';

const hasEmployerMatch = (employers: EmployersResult): boolean => {
  return employers.some(employer => employer.fourOhOneKContributions);
};

export const FourOhOneKContributionsHeader: React.FC<{
  employers: EmployersResult;
  hasOnlySolo401k: boolean;
}> = ({ employers, hasOnlySolo401k }) => {
  if (hasOnlySolo401k) {
    return (
      <Text css={{ fontWeight: 600, textStyle: { base: 'text100', md: 'text200' } }}>Solo 401(k) contributions</Text>
    );
  }
  return (
    <Text css={{ fontWeight: 600, textStyle: { base: 'text100', md: 'text200' } }}>
      401(k) contributions {hasEmployerMatch(employers) ? ' and match' : ''}
    </Text>
  );
};
